import React, { createContext, useReducer, useContext } from 'react';
import { ROOT_ACTION } from './actionTypes';

const RootStateContext = createContext();
const RootDispatchContext = createContext();

const initLoginInfo = {
  isLogin: false,
  firstName: '',
  lastName: '',
  username: '',
  avatarUrl: '',
};

function rootReducer(state, action) {
  const { type, payload } = action;
  switch (type) {
    case ROOT_ACTION.SET_LOGIN_INFO: {
      const newLoginInfo = { ...initLoginInfo, isLogin: payload.isLogin };
      if (payload.isLogin) {
        newLoginInfo.firstName = payload.first_name;
        newLoginInfo.lastName = payload.last_name;
        newLoginInfo.username = payload.user_name;
        newLoginInfo.avatarUrl = payload.avatar_url;
      }

      return {
        ...state,
        loginInfo: newLoginInfo,
      };
    }

    case ROOT_ACTION.SET_PERMISSION_LIST:
      return {
        ...state,
        permissionList: payload,
      };

    case ROOT_ACTION.SET_IS_ADMIN:
      return {
        ...state,
        isAdmin: payload,
      };

    case ROOT_ACTION.SET_LOADING:
      return {
        ...state,
        loading: payload,
      };

    default:
      throw new Error('Invalid action type');
  }
}

function RootProvider({ children }) {
  const [state, dispatch] = useReducer(rootReducer, {
    loginInfo: { ...initLoginInfo },
    permissionList: null,
    isAdmin: false,
    loading: false,
  });

  return (
    <RootStateContext.Provider value={state}>
      <RootDispatchContext.Provider value={dispatch}>{children}</RootDispatchContext.Provider>
    </RootStateContext.Provider>
  );
}

function useRootState() {
  const context = useContext(RootStateContext);

  if (context === undefined) {
    throw new Error('useRootState must be used within a RootProvider');
  }
  return context;
}

function useRootDispatch() {
  const context = useContext(RootDispatchContext);

  if (context === undefined) {
    throw new Error('useRootDispatch must be used within a RootProvider');
  }
  return context;
}

export { RootProvider, useRootState, useRootDispatch };
